import React from 'react';

const Footer = () => {
  return (
    <footer className="footer text-center text-secondary pt-5">
       <p className="badge bg-success p-1"><i className="fa-solid fa-wifi"></i>&nbsp;Connected</p>
      <h4>Paracosm Labs Orbital Station</h4>
    </footer>
  );
};

export default Footer;
